import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import MainLayout from "./layouts/MainLayout";
import Home from "./pages/Home";
import {SiteProvider} from "./context/SiteContext";

function App() {
    return (
        <Router basename="/">
            <SiteProvider>
                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                />
                <Routes>
                    <Route element={<MainLayout/>}>
                        <Route path="/" element={<Home/>}/>
                        <Route path="*" element={<Home/>}/>
                    </Route>
                </Routes>
            </SiteProvider>
        </Router>
    );
}

export default App;
